"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = exports.SnackbarProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const useGlobalError_1 = require("../../hooks/useGlobalError");
const SnackbarContext = (0, react_1.createContext)(undefined);
// Custom alert component for Snackbar
const Alert = react_1.default.forwardRef(function Alert(props, ref) {
    return (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ elevation: 6, ref: ref, variant: "filled" }, props));
});
const SnackbarProvider = ({ children }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [message, setMessage] = (0, react_1.useState)('');
    const [severity, setSeverity] = (0, react_1.useState)('info');
    const globalError = (0, useGlobalError_1.useGlobalError)();
    // Function to trigger the snackbar
    const triggerSnackbar = (message, severity) => {
        setMessage(message);
        setSeverity(severity);
        setOpen(true);
    };
    // Function to close the snackbar
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    (0, react_1.useEffect)(() => {
        if (globalError.message)
            triggerSnackbar(globalError.message, 'error');
    }, [globalError]);
    // Expose the triggerSnackbar function via a hook
    return ((0, jsx_runtime_1.jsxs)(SnackbarContext.Provider, { value: { triggerSnackbar }, children: [children, (0, jsx_runtime_1.jsx)(Snackbar_1.default, { open: open, autoHideDuration: 5000, onClose: handleClose, children: (0, jsx_runtime_1.jsx)(Alert, { onClose: handleClose, severity: severity, children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: message } }) }) })] }));
};
exports.SnackbarProvider = SnackbarProvider;
const useSnackbar = () => {
    const context = (0, react_1.useContext)(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
exports.useSnackbar = useSnackbar;
